import { EquipmentApi } from '../../../admin/adminAddEquip/service';

/**
 * Service unificado para o formulário de equipamentos no modal.
 * Inclui todas as funções: serviços, equipamento, fotos e laudos.
 */

// === SERVIÇOS ===
async function loadServices() {
    try {
        const response = await EquipmentApi.listServices();
        return response.data || [];
    } catch (error) {
        console.error('Erro ao carregar serviços:', error);
        return [];
    }
}

// === EQUIPAMENTO ===
async function loadEquipment(id) {
    try {
        const response = await EquipmentApi.getById(id);
        return response.data;
    } catch (error) {
        console.error('Erro ao carregar equipamento:', error);
        return null;
    }
}

async function saveEquipment(data, id = null) {
    try {
        const response = id
            ? await EquipmentApi.update(id, data)
            : await EquipmentApi.create(data);
        return {
            success: true,
            data: response.data,
            message: id ? 'shared_service_msg_equip_updated' : 'shared_service_msg_equip_created'
        };
    } catch (error) {
        console.error('Erro ao salvar equipamento:', error);
        return {
            success: false,
            message: 'shared_service_msg_equip_save_error'
        };
    }
}

// === FOTOS ===
async function uploadPhoto(equipId, momento, file) {
    try {
        const form = new FormData();
        form.append('equipamento_id', equipId);
        form.append('momento', momento);
        form.append('foto', file);
        const response = await EquipmentApi.uploadPhoto(form);
        return {
            success: true,
            data: response.data,
            message: 'shared_service_msg_photo_uploaded'
        };
    } catch (error) {
        console.error('Erro ao enviar foto:', error);
        return {
            success: false,
            message: 'shared_service_msg_photo_upload_error'
        };
    }
}

async function deletePhoto(id) {
    try {
        await EquipmentApi.deletePhoto(id);
        return { success: true, message: 'shared_service_msg_photo_removed' };
    } catch (error) {
        console.error('Erro ao excluir foto:', error);
        return { success: false, message: 'shared_service_msg_photo_remove_error' };
    }
}

// === LAUDOS ===
async function uploadLaudo(equipId, nome, file) {
    try {
        const form = new FormData();
        form.append('equipamento_id', equipId);
        form.append('nome', nome);
        form.append('laudo', file);
        const response = await EquipmentApi.uploadLaudo(form);
        return {
            success: true,
            data: response.data,
            message: 'shared_service_msg_laudo_uploaded'
        };
    } catch (error) {
        console.error('Erro ao enviar laudo:', error);
        return {
            success: false,
            message: 'shared_service_msg_laudo_upload_error'
        };
    }
}

async function deleteLaudo(id) {
    try {
        await EquipmentApi.deleteLaudo(id);
        return { success: true, message: 'shared_service_msg_laudo_removed' };
    } catch (error) {
        console.error('Erro ao excluir laudo:', error);
        return { success: false, message: 'shared_service_msg_laudo_remove_error' };
    }
}

// === IMAGEM RESIZE ===
function resizeImage(file, maxSize = 1000) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
            const img = new Image();
            img.onload = () => {
                let w = img.width;
                let h = img.height;

                if (w > h && w > maxSize) { h *= maxSize / w; w = maxSize; }
                else if (h > maxSize) { w *= maxSize / h; h = maxSize; }

                const canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = h;

                canvas.getContext('2d').drawImage(img, 0, 0, w, h);
                canvas.toBlob(resolve, 'image/jpeg', 0.85);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
}

export const EquipmentFormService = {
    loadServices,
    loadEquipment,
    saveEquipment,
    uploadPhoto,
    deletePhoto,
    uploadLaudo,
    deleteLaudo,
    resizeImage
};

